import styled from "@emotion/styled";
import { Stack } from "@mui/material";
import moment from "moment/moment";
import EtDatePicker from "mui-ethiopian-datepicker";
import { forwardRef } from "react";

const StyledDateField = styled(EtDatePicker)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "4px",
    backgroundColor: theme.palette.background.paper,
    borderColor: "rgb(179, 179, 179)",
    outline: "none",
    "& fieldset": {
      borderColor: "rgb(179, 179, 179)",
      borderWidth: "0.5px"
    },
    "&:hover fieldset": {
      borderColor: "rgb(179, 179, 179)",
      borderWidth: "0.5px"
    },
    "&.Mui-focused fieldset": {
      borderColor: "rgb(179, 179, 179)",
      borderWidth: "0.5px"
    }
  },
  "& .MuiInputBase-root.Mui-disabled": {
    backgroundColor: "rgb(255, 255, 255)",
    borderColor: "rgb(179, 179, 179)",
    outline: "none",
    "& fieldset": {
      borderColor: "rgb(179, 179, 179)",
      borderWidth: "0.5px"
    }
  }
}));

export const EthiopianDateField = forwardRef(
  ({ label, width = "100%", value, onChange, ...rest }, ref) => {
    // Pass the date string directly to EtDatePicker
    const dateValue = value ? moment(value).toDate() : null;

    const handleChange = newDate => {
      if (newDate) {
        onChange({ target: { value: moment(newDate).format("YYYY-MM-DD") } });
      } else {
        // Emit null (not "") on clear. yup's .date().nullable() accepts null
        // but tries to cast "" to a Date, which fails with "Invalid Date".
        onChange({ target: { value: null } });
      }
    };

    return (
      <Stack width={width}>
        <StyledDateField
          size="small"
          label={label}
          InputLabelProps={{ shrink: true }}
          inputRef={ref}
          value={dateValue}
          onChange={handleChange}
          {...rest}
        />
      </Stack>
    );
  }
);

EthiopianDateField.displayName = "EthiopianDateField";
